import React, { useState } from "react";
import { Input, Button } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import http from "../../../services/http";
import {
  applyDiscount,
  applyCoupon,
  revokeDiscount,
} from "../../../ReduxToolkit/Reducers/CartReducer";
import { getAPIURL, getVendorID } from "../../../services/helper";

export default function DiscountHandler() {
  const dispatch = useDispatch();
  const [input, setInput] = useState("");
  const { discount, applied_coupon, applied_event, cartItems } = useSelector(
    (state) => state.cart
  );

  const subtotal = cartItems.reduce(
    (acc, item) => acc + item.price * item.quantity,
    0
  );
  const api_url = getAPIURL();
  const vendor_id = getVendorID();

  const handleApply = async () => {
    if (!input) {
      dispatch(applyDiscount(null));
      return;
    }

    const isManual = input.includes("%") || !isNaN(parseFloat(input));

    if (isManual) {
      dispatch(applyDiscount(input));
      toast.success("Discount applied!");
      return;
    }

    // Coupon validation via vendor-bound API
    try {
      const { data } = await http.get(
        `${api_url}/vendor-coupon?coupon=${input}&vendor_id=${vendor_id}`
      );

      if (data.success && data.data) {
        dispatch(
          applyCoupon({
            coupon: data.data,
            subtotal,
          })
        );
        toast.success(`Coupon "${data.data.code}" applied!`);
      } else {
        toast.error("Coupon not valid for this vendor.");
      }
    } catch (err) {
      console.error("Coupon validation error:", err);
      toast.error("Invalid or expired coupon.");
    }
  };

  const handleRevoke = () => {
    dispatch(revokeDiscount());
    setInput("");
    toast.info("Discount/Coupon/Event revoked.");
  };

  // Show clean format when discount is applied
  if (applied_coupon || applied_event) {
    return (
      <div className="cart-total-item">
        <span className="cart-total-label txt-primary">Discount:</span>
        <div className="d-flex align-items-center gap-2">
          <span className="cart-total-value">
            {applied_event ? applied_event : applied_coupon}
          </span>
          <Button onClick={handleRevoke} size="sm" color="danger" title="Remove discount">
            ×
          </Button>
        </div>
      </div>
    );
  }

  // Show input when no discount is applied
  return (
    <div className="cart-total-item d-flex align-items-center gap-2">
      <span className="cart-total-label txt-info">Discount:</span>
      <Input
        type="text"
        placeholder="Enter discount or coupon"
        className="discount-input"
        value={input}
        onChange={(e) => setInput(e.target.value)}
      />
      <Button onClick={handleApply} size="sm" color="primary">
        Apply
      </Button>
    </div>
  );
}
